import { Modal, ModalContent, ModalFooterWithActions, ModalFooterWithActionsType } from '@/components/modal'

interface DisconnectDialogProps {
  open: boolean
  title: string
  description: string
  confirmLabel?: string
  loading?: boolean
  onOpenChange: (open: boolean) => void
  onConfirm: () => void
}

export function DisconnectDialog({ open, title, description, confirmLabel = 'Disconnect', loading = false, onOpenChange, onConfirm }: DisconnectDialogProps) {
  return (
    <Modal open={open} onOpenChange={(nextOpen) => !loading && onOpenChange(nextOpen)}>
      <ModalContent
        title={title}
        width="md"
        height="max-sm"
        footer={
          <ModalFooterWithActions
            type={ModalFooterWithActionsType.DESTRUCTIVE}
            secondaryAction={{
              label: 'Cancel',
              onClick: () => onOpenChange(false),
              disabled: loading,
            }}
            primaryAction={{
              label: confirmLabel,
              onClick: onConfirm,
              loading: loading ? 'loading' : undefined,
            }}
          />
        }
      >
        <p className="text-sm leading-5 tracking-[-0.15px] text-brand-neutral-700">{description}</p>
      </ModalContent>
    </Modal>
  )
}
